module.exports = __webpack_public_path__ + "static/img/ellipsis.7904cb0d.svg";